export default (status: string): boolean => {
  return status === 'pending' || status === 'send_failed';
};
